import { ExpenseClassification } from "src/app/receipt-long-op/generated/domain-models/enums/generated-expense-classification";

export class ExpenseClassificationMapper {

  private static mapper = {
    [ExpenseClassification.Transport]: {
      icon: 'transport',
      color: '#fee8e9'
    },
    [ExpenseClassification.Accommodation]: {
      icon: 'rest',
      color: '#dae2f0'
    },
    [ExpenseClassification.Food]: {
      icon: 'roast',
      color: '#d7edca'
    },
    [ExpenseClassification.MileageRefound]: {
      icon: 'fill',
      color: '#FEEFC2'
    },
    [ExpenseClassification.Other]: {
      icon: 'pack',
      color: '#e0f3f3'
    }
  };

  static getIconByClassificationType(ExpenseClassification: ExpenseClassification) {
    return this.mapper[ExpenseClassification]?.icon;
  }

  static getColorByClassificationType(ExpenseClassification: ExpenseClassification) {
    return this.mapper[ExpenseClassification]?.color;
  }

  static getIconColorByClassificationType(ExpenseClassification: ExpenseClassification) {
    return this.darkenColor(this.mapper[ExpenseClassification]?.color, 60);
  }

  private static darkenColor(hex: string, percent: number): string {
    const normalizedHex = hex?.replace('#', '');
    const num = parseInt(normalizedHex, 16);
    const amount = Math.round(2.55 * percent);

    const r = Math.max(0, Math.min(255, (num >> 16) - amount));
    const g = Math.max(0, Math.min(255, ((num >> 8) & 0x00FF) - amount));
    const b = Math.max(0, Math.min(255, (num & 0x0000FF) - amount));

    return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
  }
}
